// ── Domain & Route Configuration ──

// Platform hosts are configurable at build time (no provider/domain hard-coded):
//   REACT_APP_PLATFORM_BASE   base domain, e.g. "servora.se"
//   REACT_APP_PLATFORM_HOSTS  extra hosts that show the PLATFORM site (comma list),
//                             e.g. "staging.servora.se" on a staging server
//   REACT_APP_PRODUCTION_HOSTS hosts where the "Coming soon" mask may apply
const csv = (v) => (v || '').split(',').map((x) => x.trim().toLowerCase()).filter(Boolean);

export const PLATFORM_BASE = (process.env.REACT_APP_PLATFORM_BASE || 'servora.se').toLowerCase();

// Main platform hosts (no tenant resolution needed)
export const PLATFORM_MAIN_HOSTS = Array.from(new Set([
  PLATFORM_BASE,
  `www.${PLATFORM_BASE}`,
  'localhost',
  ...csv(process.env.REACT_APP_PLATFORM_HOSTS),
]));

// Hosts treated as "production" (e.g. Coming-soon mask). Staging is NOT listed.
export const PRODUCTION_HOSTS = (() => {
  const l = csv(process.env.REACT_APP_PRODUCTION_HOSTS);
  return l.length ? l : [PLATFORM_BASE, `www.${PLATFORM_BASE}`];
})();

export function isProductionHost(hostname) {
  return PRODUCTION_HOSTS.includes((hostname || '').toLowerCase());
}

// Production-facing public URL — used in API docs, code snippets, embed widgets, SMS links.
// Always points to production (never preview) so customers see the right URL.
export const PUBLIC_URL = `https://${PLATFORM_BASE}`;

// Known custom domain → slug mapping
export const KNOWN_CUSTOM_DOMAINS = {
};

// Path → page name mapping for standalone public pages
export const PAGE_PATH_MAP = {
  '/om-oss': 'om-oss',
  '/integritetspolicy': 'integritetspolicy',
  '/anvandarvillkor': 'anvandarvillkor',
  '/personuppgiftsbitradesavtal': 'personuppgiftsbitradesavtal',
  '/dpa': 'personuppgiftsbitradesavtal',
};
